import { useState, useEffect } from 'react'
import { type SupplementalNutritionModel, type lookup } from '../../../core/types'
import { Modal } from '../../../Components/Modal'
import { DatePickerWithLabel } from '../../../Components/DatePicker'
import { SelectWithLabel } from '../../../Components/SelectWithLabel'
import { sendGet } from '../../../hooks/use-fetch'

export interface SupplementalNutritionAddEditProps {
  record: SupplementalNutritionModel
  open: boolean
  errors?: string[] | undefined
  onClose: () => void
  onSubmit: (newValue: SupplementalNutritionModel) => void
}

export function SupplementalNutritionAddEdit (props: SupplementalNutritionAddEditProps): JSX.Element {
  const [supplementalNutrition, setSupplementalNutrition] = useState(props.record)
  const [eligibilityList, setEligibilityList] = useState<lookup[]>([])
  const [sourceList, setSourceList] = useState<lookup[]>([])

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const { response: rsp, error } = await sendGet('/SupplementalNutrition/EligibilityList', {})
      if (error[0] === '') {
        setEligibilityList(rsp)
      }

      const { response: rsp2, error: error2 } = await sendGet('/SupplementalNutrition/SourceList', {})
      if (error2[0] === '') {
        setSourceList(rsp2)
      }
    }
    void loadData()
  }, [props])

  const dateChanged = (field: string, newDate: Date | null): void => {
    setSupplementalNutrition({ ...supplementalNutrition, [field]: newDate })
  }

  const handleChange = (e: any): void => {
    setSupplementalNutrition({ ...supplementalNutrition, [e.target.name]: e.target.value })
  }

  const handleClose = (): void => {
    props.onClose()
  }

  const handleSubmit = (): void => {
    props.onSubmit(supplementalNutrition)
  }

  const content = <>
    {props.errors?.map((err) => (
      <li key={err} style={{ color: 'red', padding: '10px 0 0' }}>
        {err}
      </li>
    ))}
    <div>
      <DatePickerWithLabel
        dataTestId="start-date"
        label='Start Date'
        name='startDate'
        onChange={(date: Date | null) => { dateChanged('startDate', date) }}
        value={supplementalNutrition.startDate}
      />
      <DatePickerWithLabel
        dataTestId="end-date"
        label='End Date'
        name='endDate'
        onChange={(date: Date | null) => { dateChanged('endDate', date) }}
        value={supplementalNutrition.endDate}
      />
      <SelectWithLabel
        name="supplementalNutritionEligibilityID"
        label="Eligibility"
        width="100%"
        value={supplementalNutrition.supplementalNutritionEligibilityID}
        options={eligibilityList}
        onChange={handleChange}
      />
      <SelectWithLabel
        name="supplementalNutritionSourceID"
        label="Source"
        width="100%"
        value={supplementalNutrition.supplementalNutritionSourceID}
        options={sourceList}
        onChange={handleChange}
      />
    </div>
  </>
  return <Modal
    data-testid="modal"
    open={props.open}
    title={`${props.record.id === 0 ? 'Add' : 'Edit'} Supplemental Nutrition Eligibility Period`}
    confirmationContent={content}
    onClose={handleClose}
    onConfirm={handleSubmit}
  />
}
